import { useState } from "react";
import GetIcon from "../../../../utils/Icon";
import GeneralDetails from "./GeneralDetails";
import TaxDetails from "./TaxDetails";
import RegistrationDetails from "./RegistrationDetails";
import printerimg from "../../../../assets/print.png";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";
import { usePostCreateCompanyMutation } from "../../../../store/api/companyapi";
import { useNavigate } from "react-router-dom";

const CompanyForm = () => {
  const nvg = useNavigate();
  const [activeTab, setActiveTab] = useState(1);
  const [CreateCompany] = usePostCreateCompanyMutation();
  const [isSubmitting, setIsSubmitting] = useState(false); 
  const [formData, setFormData] = useState({
    companyName: '',
    abbreviation: '',
    defaultCurrency: '',
    country: '',
    defaultGSTRate: '',
    defaultHolidayList: '',
    defaultLetterHead: '',
    domain: '',
    taxID: '',
    dateOfEstablishment: '',
    parentCompany: '',
    gstinUin: '',
    pan: '',
    gstCategory: '',
    registrationDetails: '',
    isgroup: false,
  });

  const [fieldErrors, setFieldErrors] = useState({
    companyName: false,
    abbreviation: false,
    defaultCurrency: false,
  });

  const [apiResponse, setApiResponse] = useState({
    show: false,
    type: 'error',
    message: ''
  });

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    
    if (fieldErrors[field]) {
      setFieldErrors(prev => ({
        ...prev,
        [field]: false
      }));
    }
  };

  const validateForm = () => {
    const errors = {};
    let isValid = true;
    
    setFieldErrors(errors);
    return isValid;
  };

  const handleSubmit = async () => {
  const requiredFields = ['companyName','abbreviation', 'defaultCurrency',]; // Add more fields if needed
  const newErrors = {};

  // Check required fields
  requiredFields.forEach(field => {
    if (!formData[field]?.trim()) {
      newErrors[field] = true;
    }
  });

  const hasError = Object.keys(newErrors).length > 0;

  setFieldErrors(newErrors);

  if (hasError) {
    setApiResponse({
      show: true,
      type: 'error',
      message: 'Please fill all the required fields.'
    });
    return;
  }

  setIsSubmitting(true);

  try {
    const payload = {
      company_name: formData.companyName,
      abbr: formData.abbreviation,
      default_currency: formData.defaultCurrency || '',
      country: formData.country || '',
      default_gst_rate: formData.defaultGSTRate || '',
      domain: formData.domain,
      default_holiday_list: formData.defaultHolidayList || '',
      default_letter_head: formData.defaultLetterHead || '',
      tax_id: formData.taxID,
      date_of_establishment: formData.dateOfEstablishment || '',
      parent_company: formData.parentCompany || '',
      gstin: formData.gstinUin || '',
      pan: formData.pan || '',
      gst_category: formData.gstCategory || '',
      registration_details: formData.registrationDetails || '',
      is_group: formData.isgroup || ''
    };

    const response = await CreateCompany(payload);

   if (response.error) {
  const errorData = response.error.data || {};
  let messages = [];

  if (errorData._error_message) {
    messages.push(errorData._error_message);
  }

  if (errorData._server_messages) {
    try {
      const serverMsgs = JSON.parse(errorData._server_messages);
      serverMsgs.forEach(msgStr => {
        const parsed = JSON.parse(msgStr);
        if (parsed.message) messages.push(parsed.message);
      });
    } catch (e) {
      messages.push(errorData._server_messages); // fallback raw
    }
  }

  if (errorData.exception && !messages.includes(errorData.exception)) {
    messages.push(errorData.exception);
  }

  if (errorData.exc_type && !messages.includes(errorData.exc_type)) {
    messages.push(errorData.exc_type);
  }

  const finalMessage = messages
    .map(msg => msg.replace(/<[^>]+>/g, '').trim())
    .filter(Boolean)
    .join("\n");

  setApiResponse({
    show: true,
    type: 'error',
    message: finalMessage || "Something went wrong"
  });
  return;
}


    setApiResponse({
      show: true,
      type: 'success',
      message: 'Company created successfully'
    });

    setTimeout(() => {
      nvg("/master/company/company-list");
    }, 1500);

  } catch (error) {
    setApiResponse({
      show: true,
      type: 'error',
      message: 'Failed to create company'
    });
  } finally {
    setIsSubmitting(false);
  }
};


  return (
    <>
      {/* Full-page loader overlay */}
      {isSubmitting && (
        <div className="loader-overlay">
          <div className="loader-spinner">
            <div className="spinner-border" style={{color:'#270b79'}} role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      )}

      <FormLayout
        title="New Company"
        breadcrumbs={[
          { label: "Company" },
          { label: "Company List", url: "/master/company/company-list" }
        ]}
        status={'hide'}
        actionButtons={
          <>
           
            <Button 
              className="custom-btn-00989"
              onClick={handleSubmit}
              iconName="LuFilePlus2"
              style={{gap:'2px',height:'28px'}}
              iconSize={12}
              disabled={isSubmitting} // Disable button during submission
            >
              {isSubmitting ? 'Saving...' : 'Save'}
            </Button>

            <Button 
              to="/" 
              className="px-2"
              imgSrc={printerimg}
              imgStyle={{ width: '21px' }}
            />
          </>
        }
      >
        <div className="" style={{ width: "100%", backgroundColor: "#fff" }}>
          <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
            <div className="d-flex justify-content-between align-items-end">
              <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                  <a 
                    className={activeTab === 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} 
                    onClick={() => setActiveTab(1)}
                  >
                    General Details{activeTab === 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                  </a>
                </li>
              </ul>

              <div className="d-flex align-items-center mb-2 px-3" style={{ gap: "2px", fontSize: '12px' }}>
                <span style={{ position: 'relative', top: '-1px' }}>
                  <GetIcon iconName="CgAttachment" size={12} />
                </span>
                <span className="fw-semibold" style={{ color: "#391F84" }}>
                  Attachments
                </span>
              </div>
            </div>
          </div>

          <div className="mt-2 py-2" style={{ width: "100%", backgroundColor: "#fff" }}>
            <div className="col-12">
              <div className="sidebarbox m-0 px-4 py-2">
                <GeneralDetails 
                  formData={formData} 
                  handleChange={handleInputChange} 
                  errors={fieldErrors} 
                />
                <TaxDetails 
                  formData={formData} 
                  handleChange={handleInputChange} 
                  errors={fieldErrors} 
                />
                <RegistrationDetails
                  formData={formData} 
                  handleChange={handleInputChange} 
                  errors={fieldErrors} 
                />
              </div>
            </div>
          </div>
        </div>

        <ApiResponseBox
          poptype={apiResponse.type}
          show={apiResponse.show}
          errorMessage={apiResponse.message}
          onClose={() => setApiResponse(prev => ({...prev, show: false}))}
        />
      </FormLayout>
    </>
  );
};

export default CompanyForm;